import React, { HTMLAttributes } from "react";
import { FaFacebook, FaInstagram, FaWhatsapp, FaYoutube } from "react-icons/fa";

interface ISocialMediaSection {}

type TSocialMediaSectionProps = ISocialMediaSection &
  HTMLAttributes<HTMLDivElement>;

const SOCIALMEDIAS: {
  icon: JSX.Element;
  link: string;
  disabled: boolean;
}[] = [
  {
    icon: (
      <FaFacebook size={20} className="hover:text-sky-600" />
    ) as JSX.Element,
    link: "https://www.facebook.com/asgardev",
    disabled: false,
  },
  {
    icon: (
      <FaInstagram size={20} className="hover:text-purple-500" />
    ) as JSX.Element,
    link: "https://www.instagram.com/asgard.ev",
    disabled: false,
  },
  {
    icon: (
      <FaYoutube size={20} className="hover:text-red-500" />
    ) as JSX.Element,
    link: "/",
    disabled: true,
  },
  {
    icon: (
      <FaWhatsapp size={20} className="hover:text-green-600" />
    ) as JSX.Element,
    link: "https://wa.me/85284013062",
    disabled: false,
  },
];

const SocialMediaSection: React.FC<TSocialMediaSectionProps> = (props) => {
  const { ...otherProps } = props;

  return (
    <div className="flex flex-row gap-4" {...otherProps}>
      {SOCIALMEDIAS.map((socialMedia, index) => {
        if (socialMedia.disabled) {
          return (
            <div
              key={index}
              className={`transition-all duration-300 ease-in-out hover:scale-110`}
            >
              <>{socialMedia.icon}</>
            </div>
          );
        } else {
          return (
            <a
              href={socialMedia.link}
              target="_blank"
              rel="noreferrer"
              key={index}
              className={`transition-all duration-300 ease-in-out hover:scale-110`}
            >
              {socialMedia.icon}
            </a>
          );
        }
      })}
    </div>
  );
};

export default SocialMediaSection;
